export const en = {
    'create-group-error': 'Error when creating group',
    'geo-empty-regions': 'Select display regions',
    'warning-about-changes': 'Changes will not be saved. Continue?',
    'warning-about-changes-internal': 'Unsaved groups will be lost. Continue?',
    'warning-about-empty-retargeting-conditions':
        'You are saving a group that will be targeted at all users in the selected region. Continue?'
};
